import { inject } from 'aurelia-framework';
import { NewInstance } from 'aurelia-dependency-injection';
import { UserService } from '../Advertiser.SharedPortal/services/user-service';
import { AdvertiserService } from '../Advertiser.SharedPortal/services/advertiser-service';
import { User } from '../models/user';
import {
    ValidationController,
    validateTrigger,
    ValidationRules,
    ValidateBindingBehavior,
    ValidationRenderer
} from 'aurelia-validation';
import { LoggerService } from '../Advertiser.SharedPortal/services/logger-service';
import { StatusService } from '../Advertiser.SharedPortal/services/status-service';
import { MultiObserverService } from '../Advertiser.SharedPortal/services/multi-observer-service';
var config = require('../../config.js');

@inject(
    UserService,
    NewInstance.of(ValidationController),
    LoggerService,
    StatusService,
    MultiObserverService,
    AdvertiserService
)
export class UserRegistration {
    constructor(userService, controller, logger, status, multiObserver, AdvertiserService) {
        this.userService = userService;
        this.controller = controller;
        this.logger = logger;
        this.status = status;
        this.multiObserver = multiObserver;
        this.advertiserService = AdvertiserService;

        this.user = new User();
        this.submitted = false;
        this.errorMessage = '';
        this.heading = 'Delty User Registration';
        this.controller.validateTrigger = validateTrigger.manual;
        this.roles = ['Advertiser', 'AccountManager', 'Admin', 'AdvDownload', 'Publisher'];
        this.advertisers = [];
        this.selectedAdvertisers = [];
        this.selectedAdvertisersNames = [];
        this.myClickCallback = this.clickInput.bind(this);

        this.myKeypressCallback = this.keypressInput.bind(this);
    }

    activate() {
        let that = this;
        this.configStatus();
        this.advertiserService.getAdvertisers().then(function (response) {
            that.advertisers = response.sort((a, b) =>
                a.AdvertiserName.localeCompare(b.AdvertiserName)
            );
        });
        this.multiObserver.observe(
            this.user,
            ['firstName', 'lastName', 'emailAddress', 'phoneNumber', 'roleKey'],
            function () {
                that.status.dirty();
            }
        );
        window.addEventListener('keypress', this.myKeypressCallback, false);
        window.addEventListener('click', this.myClickCallback, false);
    }

    deactivate() {
        window.removeEventListener('keypress', this.myKeypressCallback);
        window.removeEventListener('click', this.myClickCallback);
    }

    keypressInput(e) {
        if (e.key === 'Enter') {
            this.onSubmit();
        }
    }

    configStatus() {
        // statuses:  dontchange, clean, dirty, working, loading, saving, success, error
        this.status.texts = [
            '',
            'Register New User',
            'Register New User',
            'Working',
            '',
            '',
            'Done',
            'Error'
        ];
        this.status.classes = [
            '',
            'btn-disabled',
            'btn-enabled',
            'btn-processing',
            '',
            '',
            'btn-success',
            'btn-error'
        ];
        this.status.clean();
    }

    onSubmit() {
        this.logger.debug('onSubmit() called');
        let that = this;

        if (this.user.role === 'Admin') {
            this.user.roleKey = '';
        }

        if (this.user.role === 'AccountManager') {
            if (this.selectedAdvertisers.length > 0) {
                this.user.roleKey = '';
                this.user.AdvertiserKeys = [];
                this.selectedAdvertisers.map(advertiser => {
                    this.user.AdvertiserKeys.push(advertiser.AdvertiserKey);
                });
            } else {
                this.errorMessage = 'Account Managers must have at least 1 Assigned Advertiser';
                return;
            }
        }

        this.controller.validate().then(result => {
            if (result.valid && this.registrationPermitted()) {
                this.status.working();
                this.errorMessage = '';
                this.controller.reset();

                this.userService.signupUser(this.user).then(response => {
                    if (response && response[0] !== 'Success') {
                        this.errorMessage = response;
                        this.submitted = false;
                        this.status.set(
                            this.status.statuses.error,
                            this.status.statuses.done,
                            config.buttonReset
                        );
                    } else {
                        this.errorMessage = '';
                        this.status.set(
                            this.status.statuses.success,
                            this.status.statuses.clean,
                            config.buttonReset
                        );
                        setTimeout(function () {
                            that.submitted = true;
                        }, 1500);
                    }
                });
            } else if (!this.registrationPermitted()) {
                this.errorMessage = 'You are not permitted to register an Admin User';
            }
        });
    }

    getSelectedAdvertiserChanged(selectedAdvertisers) {
        var that = this;
        var advertiserNameArray = [];
        if (selectedAdvertisers.length > 0) {
            selectedAdvertisers.map(advertiser => {
                advertiserNameArray.push(' ' + advertiser.AdvertiserName);
            });
        }
        this.selectedAdvertisersNames = advertiserNameArray;
    }

    registrationPermitted() {
        let registeringUser = window.localStorage.getItem('Username');

        if (
            config.env === 'PROD' &&
            this.user.role === 'Admin' &&
            registeringUser !== 'kowens@qw-corp.com' &&
            registeringUser !== 'tpantig@qw-corp.com'
        ) {
            return false;
        }

        return true;
    }

    onSelectAssignedAdvertisers() {
        this.showAssignedAdvertisersSelect = this.showAssignedAdvertisersSelect ? false : true;
        this.setSelectedAdvertisers();
    }

    setSelectedAdvertisers() {
        this.selectedAdvertisers = [];
        this.selectedAdvertisersNames = [];
        this.advertisers.forEach(advertiser => {
            if (advertiser.active) {
                this.selectedAdvertisers.push(advertiser);
                this.selectedAdvertisersNames.push(advertiser.AdvertiserName);
            }
        });
    }

    deactivateAdvertiser(advertiser) {
        advertiser.active = false;
        this.setSelectedAdvertisers();
    }

    clickInput(e) {
        if (e.target.className.indexOf('select-advertisers') == -1) {
            this.showAssignedAdvertisersSelect = false;
            this.setSelectedAdvertisers();
        }
    }
}

ValidationRules.ensure(p => p.firstName)
    .required()
    .ensure(p => p.lastName)
    .required()
    .ensure(p => p.emailAddress)
    .required()
    .ensure(p => p.emailAddress)
    .email()
    .withMessage('Email address is improperly formated (please ensure it is all lowercase)')
    .ensure(p => p.phoneNumber)
    .required()
    .ensure(p => p.roleKey)
    .required()
    .when(p => p.role != 'Admin')
    .minLength(8)
    .maxLength(8)
    .withMessage('Role Key must be 8 characters long')
    .on(User);
